/**
 * The four states the review queue knows. `creating` and `creation_failed` are
 * technical states of the request being written and are not values the queue
 * accepts: a request that never became pending does not exist for the review.
 */
export const MANAGED_DROP_REVIEW_STATUSES = [
  'pending',
  'approved',
  'rejected',
  'invalidated',
] as const;

/**
 * How the four review states read, and how they look. An unknown state still
 * has to reach the admin as a word rather than a raw identifier: the server
 * owns this vocabulary and may grow it without a frontend release.
 */
const STATUS_LABELS: Record<string, string> = {
  pending: 'In attesa',
  approved: 'Approvata',
  rejected: 'Rifiutata',
  invalidated: 'Non più valida',
};

const STATUS_COLORS: Record<
  string,
  'warning' | 'success' | 'error' | 'default'
> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  invalidated: 'default',
};

export const formatManagedDropReviewStatus = (status: string) =>
  STATUS_LABELS[status] ?? status;

export const managedDropReviewStatusColor = (status: string) =>
  STATUS_COLORS[status] ?? 'default';
